import { FC, PropsWithChildren } from "react";
import { Card } from "antd";

import styles from './index.module.scss'

type InfoMessagesCardProps = {
  title?: string;
}

export const InfoMessagesCard: FC<PropsWithChildren<InfoMessagesCardProps>> = ({ children, title }) => {
  return(
    <Card
      title={(
        <div className={styles.title}>
          {title}
        </div>
      )}
    >
      <div className={styles.body}>
        {children}
      </div>
    </Card>
  )
}